// The **play boundary** (`deathmatch-world` D-6): the world-space square bees actually stop
// at. `waggle-sim` clamps every bee to `±(field_size_u / 2 + world.play_margin_u)`, so on a
// world with a configured apron — the deathmatch's is 200 u — the wall is not the field edge,
// and drawing the field edge would draw the wrong line. Pure, like `bloom-ring`: the paint
// itself is GPU-real and device-exercised, the geometry is unit-tested here.

/**
 * The half-extent of the square the movement clamp stops bees at: `fieldSize / 2` plus the
 * margin. A missing, negative or non-finite margin is treated as none — it arrives over the
 * wire, and a wall drawn *inside* the field the hives and flowers sit on is worse than the
 * field edge.
 */
export function playBoundaryHalf(fieldSize: number, playMarginU: number | undefined): number {
  const margin = playMarginU !== undefined && Number.isFinite(playMarginU) && playMarginU > 0
    ? playMarginU
    : 0;
  return fieldSize / 2 + margin;
}
